module.exports = __webpack_public_path__ + "static/premios@2xl-56fffc34b28145de32ed37f77becadb4.png";